// 生产用
export const API_URL = '/gymapi';
export const BASE_URL = '';

// 开发用
// export const API_URL = 'https://gymdev.jiahenghealth.com/gymapi';
// export const BASE_URL = 'https://gymdev.jiahenghealth.com/';
